<template>
	<div class="part_work">
		<div class="part_pc" v-if="!isPhone">
			<div class="party_com">
				<div class="par_list1 flex3">
					<div class="news_item1" v-for="(item,index) in tabdata" :key="index" v-if="index<3" @click="toPartyDetail(item)">
						<div class="news_img">
							<img :src="item.image">
						</div>
						<div class="news_text">
							<div class="news_time mt_10">{{item.addtime2}}</div>
							<div class="ellip2 news_des1 mt_5">{{item.title}}</div>
							<div class="ellip2 news_des2 mt_15">{{item.desc}}</div>
						</div>
					</div>
				</div>
				<div class="par_list2">
					<div class="news_item2 flex3" v-for="(item,index) in tabdata" :key="index" v-if="index>2"
						@click="toPartyDetail(item)">
						<div class="news_img">
							<img :src="item.image">
						</div>
						<div class="news_text">
							<div class="ellip news_des1 mt_10">{{item.title}}</div>
							<div class="news_time mt_5">{{item.addtime2}}</div>
							<div class="ellip3 news_des2 mt_15">{{item.desc}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex2 mt_60" v-if="tabdata.length">
				<pagination1 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
					@page-change="handlePageChange" />
			</div>
		</div>
		<div class="part_ph" v-if="isPhone">
			<div class="party_com">
				<div class="par_list2">
					<div class="news_item2 flex3" v-for="(item,index) in tabdata" :key="index" @click="toPartyDetail(item)">
						<div class="news_img">
							<img :src="item.image">
						</div>
						<div class="news_text">
							<div class="ellip news_des1 mt_5">{{item.title}}</div>
							<div class="news_time mt_5">{{item.addtime2}}</div>
							<div class="ellip news_des2 mt_15">{{item.desc}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex2 mt_20" v-if="tabdata.length">
				<pagination2 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
					@page-change="handlePageChange" />
			</div>
		</div>
	</div>
</template>

<script>
import pagination1 from "../../components/pagination1.vue";
import pagination2 from "../../components/pagination2.vue";
export default {
	components: {
		pagination1,
		pagination2
	},
	data() {
		return {
			sort: '',//2=纪检监察,3=群团工作',1党建建设
			sort2: '',//1主体活动、4党建概括、5党建品牌、6先进典型
			tabdata: [],
			currentPage: 1,
			totalPage: 0,
			totalNum: 0,
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
		}
	},
	watch: {
		$route: {
			handler(newRoute, oldRoute) {
				this.tabdata = [];
				this.currentPage = 1;
				this.totalPage = 0;
				this.totalNum = 0;
				this.sort = newRoute.query.sort;
				this.sort2 = newRoute.query.sort2;
				this.partys();
			},
			deep: true
		}
	},
	created() {
		this.sort = this.$route.query.sort;
        this.sort2 = this.$route.query.sort2;
		this.partys();
	},
	methods: {
		async partys() {
			var data = {
				status: this.sort2?this.sort2:this.sort,
				page: this.currentPage - 1,
				nums: 5
			}
			const res = await this.$api.partys(data);
			if (res.code == 1) {
				this.totalNum = res.msg;
				this.totalPage = Math.ceil(Number(this.totalNum) / 5);
				if (res.data.length) {
					this.tabdata = res.data;
					for (let i = 0; i < this.tabdata.length; i++) {
                        this.tabdata[i].addtime2 = this.tabdata[i].addtime.slice(0,10);
						if (this.tabdata[i].image.indexOf('https') == -1) {
							this.tabdata[i].image = this.$staticImg + this.tabdata[i].image
						}
					}
				}
			}
		},
		handlePageChange(newPage) {
			this.currentPage = newPage;
			this.partys();
		},
		toPartyDetail(item) {
            if(this.sort2){
                this.$router.push("/partyBuilding/partyDetail?id=" + item.id + "&sort=" + this.sort + "&sort2=" + this.sort2);
            }else{
                this.$router.push("/partyBuilding/partyDetail?id=" + item.id + "&sort=" + this.sort);
            }
		}
	}
}
</script>

<style lang="scss">
.part_work {
	.part_pc {
		.party_com {
			.par_list1 {
				align-items: flex-start;
				.news_item1 {
					width: 300px;
					margin-right: 40px;
					cursor: pointer;
					.news_img {
						width: 300px;
						height: 190px;
						overflow: hidden;
						img {
							width: 300px;
                            height: 190px;
							transition: transform 0.5s ease;
							&:hover {
								transform: scale(1.05);
							}
						}
					}
					&:nth-child(3) {
						margin-right: 0;
					}
					.news_text {
						background-color: #f8f8f8;
						padding: 1px 12px 20px 12px;
						.news_time {
							font-size: 16px;
							color: #b6b6b6;
							line-height: 1.6;
						}
						.news_des1 {
							font-size: 18px;
							color: #000;
							line-height: 1.6;
                            height: 58px;
							&:hover {
								color: #003f99;
							}
						}
						.news_des2 {
							font-size: 16px;
							color: #898989;
							line-height: 1.6;
                            height: 26px;
							&:hover {
								color: #003f99;
							}
						}
					}
				}
			}
			.par_list2 {
				margin-top: 45px;
				.news_item2 {
					background-color: #f8f8f8;
					padding: 15px;
					margin-bottom: 30px;
					cursor: pointer;
					.news_img {
						width: 300px;
						height: 190px;
						overflow: hidden;
						img {
							width: 300px;
                            height: 190px;
                            transition: transform 0.5s ease;
							&:hover {
								transform: scale(1.05);
							}
						}
					}
					.news_text {
						padding: 0 12px 30px 10px;
						flex: 1;
						width: 0;
						margin-left: 20px;
						.news_time {
							font-size: 16px;
							color: #b6b6b6;
							line-height: 1.6;
						}
						.news_des1 {
							font-size: 17px;
							color: #000;
							line-height: 1.6;
							&:hover {
								color: #003f99;
							}
						}
						.news_des2 {
							font-size: 16px;
							color: #898989;
							line-height: 1.8;
							min-height: 82px;
							&:hover {
								color: #003f99;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1600px) {
		.part_pc {
			.party_com {
				.par_list1 {
					.news_item1 {
						width: 255px;
						margin-right: 40px;
						.news_img {
							width: 255px;
							height: 162px;
							img {
								width: 255px;
								height: 162px;
							}
						}
					}
				}
				.par_list2 {
					margin-top: 45px;
					.news_item2 {
						cursor: pointer;
						.news_img {
							width: 255px;
							height: 162px;
							img {
								width: 255px;
								height: 162px;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.part_pc {
			.party_com {
				.par_list1 {
					.news_item1 {
						width: 225px;
						margin-right: 40px;
						.news_img {
							width: 220px;
							height: 162px;
							img {
								width: 220px;
							}
						}
					}
				}
				.par_list2 {
					margin-top: 45px;
					.news_item2 {
						cursor: pointer;
						.news_img {
							width: 255px;
							height: 162px;
							img {
								width: 255px;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1300px) {
		.part_pc {
			.party_com {
				.par_list1 {
					.news_item1 {
						width: 196px;
						margin-right: 30px;
						.news_img {
							width: 196px;
							height: 150px;
							img {
								width: 196px;
							}
						}
					}
				}
				.par_list2 {
					margin-top: 45px;
					.news_item2 {
						cursor: pointer;
						.news_img {
							width: 255px;
							height: 162px;
							img {
								width: 255px;
							}
						}
					}
				}
			}
		}
	}
	.part_ph {
		padding: 0.3rem;
		.party_com {
			.par_list2 {
				.news_item2 {
					background-color: #f8f8f8;
					padding: 0.31rem;
					align-items: flex-start;
					margin-bottom: 0.5rem;
					cursor: pointer;
					.news_img {
						width: 3.8rem;
						height: 2.2rem;
						overflow: hidden;
						img {
							width: 3.8rem;
							height: 2.2rem;
						}
					}
					.news_text {
						flex: 1;
						width: 0;
						margin-left: 0.3rem;
						.news_time {
							font-size: 16px;
							color: #b6b6b6;
							line-height: 1.6;
							margin-top: 0.1rem;
						}
						.news_des1 {
							font-size: 0.36rem;
							color: #000;
							line-height: 1.6;
							font-weight: bold;
							&:hover {
								color: #003f99;
							}
						}
						.news_des2 {
							font-size: 0.36rem;
							color: #898989;
							line-height: 1.6;
							margin-top: 0.1rem;
							&:hover {
								color: #003f99;
							}
						}
					}
				}
			}
		}
	}
}
</style>